const _Misc = require("util/Misc");

const Ensure = {
    load : function(ensureFunction, cb){
        if(Ensure.hasOwnProperty(ensureFunction)){
            Ensure[ensureFunction](cb);
        }
    },
    loadComplete : function(module, cb){
        cb(module);
    },
    welcome : function(cb){
        require.ensure(["view/welcome/Welcome"], function(){
            let module = require("view/welcome/Welcome");
            Ensure.loadComplete(module, cb);
        });
    },
    "sign-up" : function(cb){
        require.ensure(["view/register/Register"], function(){
            let module = require("view/register/Register");
            Ensure.loadComplete(module, cb);
        });
    },
    "sign-out" : function(cb){
        require.ensure(["view/logout/Logout"], function(){
            let module = require("view/logout/Logout");
            Ensure.loadComplete(module, cb);
        });
    },
    "log-in" : function(cb){
        require.ensure(["view/login/Login"], function(){
            let module = require("view/login/Login");
            Ensure.loadComplete(module, cb);
        });
    },
    "contact-us" : function(cb){
        require.ensure(["view/contact/Contact"], function(){
            let module = require("view/contact/Contact");
            Ensure.loadComplete(module, cb);
        });
    },

    overseer : function(cb){
        require.ensure(["view/overseer/Overseer"], function(){
            let module = require("view/overseer/Overseer");
            Ensure.loadComplete(module, cb);
        });
    },

    "terms-of-service" : function(cb){
        require.ensure(["view/terms/Terms"], function(){
            let module = require("view/terms/Terms");
            Ensure.loadComplete(module, cb);
        });
    },
    /*app : function(cb){
        require.ensure(["view/app/App"], function(){
            let module = require("view/app/App");
            Ensure.loadComplete(module, cb);
        });
    },*/


    //IN L2 Modules:
    in : function(cb){
        require.ensure(["view/application/Application"], function(){
            let module = require("view/application/Application");
            Ensure.loadComplete(module, cb);
        });
    },

    "my-account" : function(cb){
        require.ensure(["apps/account/Account"], function(){
            let module = require("apps/account/Account");
            Ensure.loadComplete(module, cb);
        });
    },

    dashboard : function(cb){
        require.ensure(["apps/dashboard/Dashboard"], function(){
            let module = require("apps/dashboard/Dashboard");
            Ensure.loadComplete(module, cb);
        });
    },

    reports : function(cb){
        require.ensure(["in/reports/Reports"], function(){
            let module = require("in/reports/Reports");
            Ensure.loadComplete(module, cb);
        });
    },

    tracker : function(cb){
        require.ensure(["apps/tracker/Tracker"], function(){
            let module = require("apps/tracker/Tracker");
            Ensure.loadComplete(module, cb);
        });
    },

    budget : function(cb){
        require.ensure(["apps/budget/Budget"], function(){
            let module = require("apps/budget/Budget");
            Ensure.loadComplete(module, cb);
        });
    },

    tools : function(cb){
        require.ensure(["apps/tools/Tools"], function(){
            let module = require("apps/tools/Tools");
            Ensure.loadComplete(module, cb);
        });
    },

    contact : function(cb){
        require.ensure(["apps/contact/Contact"], function(){
            let module = require("apps/contact/Contact");
            Ensure.loadComplete(module, cb);
        });
    },

    /*//APP L2 MODULES:
    overview : function(cb){
        require.ensure(["section/dashboard/Dashboard"], function(){
            let module = require("section/dashboard/Dashboard");
            Ensure.loadComplete(module, cb);
        });
    },
    account : function(cb){
        require.ensure(["section/setting/Setting"], function(){
            let module = require("section/setting/Setting");
            Ensure.loadComplete(module, cb);
        });
    },*/



};

module.exports = Ensure;


// WEBPACK FOOTER //
// ./src/control/core/Ensure.js